import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'
import { Card } from '@wartek-id/card'

import { PANDUAN_GENERAL_URL } from 'app/KinerjaShared/utils/panduan'

import type { FC } from 'react'

export const illustration = '/illustrations/img-book-magnifying-glass-stars.png'

interface CardPanduanProps {}

/** @deprecated: use KinerjaShared/components/CardPanduan instead */
const CardPanduan: FC<CardPanduanProps> = ({}) => {
  return (
    <Card>
      <section className="flex items-center gap-6 px-6 py-4">
        <div className="flex-shrink-0">
          <img alt="" src={illustration} width={64} height={64} />
        </div>

        <div className="space-y-2">
          <Text variant="heading-md">Panduan Pengelolaan Kinerja</Text>
          <Link href={PANDUAN_GENERAL_URL} passHref>
            <Button
              as="a"
              color="blue"
              size="sm"
              className="!inline-block"
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              Pelajari panduan
            </Button>
          </Link>
        </div>
      </section>
    </Card>
  )
}
export default CardPanduan
